if (!customElements.get('recipe-grid')) {
  class RecipeGrid extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.rcg__card'));
      if (!this.cards.length) return;

      this.tabs = Array.from(this.querySelectorAll('.rcg__tab'));
      this.more = this.querySelector('.rcg__more');
      this.step = parseInt(this.dataset.step, 10) || this.cards.length;
      this.shown = this.step;
      this.filter = 'all';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.filter = tab.dataset.filter || 'all';
          this.shown = this.step;
          this.tabs.forEach((other) => {
            const on = other === tab;
            other.classList.toggle('rcg__tab--on', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          this.paint();
        });
      });

      if (this.more) {
        this.more.addEventListener('click', () => {
          const first = this.shown;
          this.shown += this.step;
          this.paint();
          const next = this.matching()[first];
          if (next) {
            const target = next.querySelector('a, .rcg__caption');
            if (target) {
              target.setAttribute('tabindex', '-1');
              target.focus();
            }
          }
        });
      }

      this.paint();
    }

    matching() {
      if (this.filter === 'all') return this.cards;
      return this.cards.filter((card) => card.dataset.category === this.filter);
    }

    paint() {
      const matching = this.matching();
      this.cards.forEach((card) => {
        card.hidden = true;
      });
      matching.slice(0, this.shown).forEach((card) => {
        card.hidden = false;
      });
      if (this.more) this.more.hidden = matching.length <= this.shown;
    }
  }

  customElements.define('recipe-grid', RecipeGrid);
}
